import Vue from "vue";
import SvgIcon from "@/basa/components/SvgIcon"; // svg组件

// register globally 用法<svg-icon iconClass="example"></svg-icon>
Vue.component("svg-icon", SvgIcon);

const req = require.context("./svg", false, /\.svg$/);
const requireAll = requireContext => requireContext.keys().map(requireContext);
requireAll(req);
